import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Col,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Badge,
  NavLink,
  NavItem,
  UncontrolledCollapse,
  Container,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  changeLanguageEnglish,
  changeLanguagePersian,
} from "components/language";
import logo from "assets/image/logo.png";
import { dropdownItems } from "fixtureData/navCoinItems";
import "assets/styles/components/variantProperty.scss";
import "assets/styles/components/navbar.scss";
import cn from "classnames";
import {
  COINNIK_MARKER_INSTAGRAM,
  COINNIK_MARKER_LINKDIN,
  COINNIK_MARKER_TWITTER,
  COINNIK_MARKET_APP_URL,
} from "configs/constants";
import Support from "./support";

const MobileMenu = ({ toggle }: any) => {
  const { t } = useTranslation();

  const socialItems = [
    { icon: "icon-twitter ", link: COINNIK_MARKER_TWITTER },
    {
      icon: "icon-instagram ",
      link: COINNIK_MARKER_INSTAGRAM,
    },
    { icon: "icon-mail", link: "mailito: info@coinnik.market" },
    {
      icon: "icon-linkdin ",
      link: COINNIK_MARKER_LINKDIN,
    },
  ];

  return (
    <DropdownMenu className="position-absolute bg-primary-one top-0 end-0 w-75 overflowY-auto collapse-full-height">
      <Container className="px-3 ">
        <DropdownItem to="/" className="">
          <img src={logo} alt="logo" className="mt-3 mb-4" />
        </DropdownItem>
        <DropdownItem tag={Link} to="">
          <Button
            href="https://coinnik.market/app/user/register"
            size="lg"
            color="warning"
            className="w-100"
          >
            <span>{t("sign up")}</span>
          </Button>
        </DropdownItem>
        <DropdownItem tag={Link} to="">
          <Button
            className="w-100"
            href="https://coinnik.market/app/user/login"
            size="lg"
            color="warning"
            outline
          >
            <span>{t("sign in")}</span>
          </Button>
        </DropdownItem>
        <DropdownItem divider className="bg-white mx-3 my-4" />
        <DropdownItem
          className="text-white fs-6 mb-4 "
          tag={Link}
          to="/show-all-markets"
        >
          {t("Instant price")}
        </DropdownItem>
        <DropdownItem
          tag={Link}
          to="/user-guide"
          className="text-white fs-6  mb-4 "
        >
          {t("user manual")}
        </DropdownItem>
        <div
          className="d-flex justify-content-between px-3  align-items-center"
          id="toggler"
        >
          <p className="fs-6 text-light">{t("Digital currencies")} </p>
          <i className="icon-chevron-down" />
        </div>
        <UncontrolledCollapse toggler="#toggler">
          <DigitalCurecnyItems />
        </UncontrolledCollapse>
        <div
          className="d-flex justify-content-between px-3  align-items-center"
          id="togglerSupport"
        >
          <p className="fs-6 text-light">{t("Support")} </p>
          <i className="icon-chevron-down" />
        </div>
        <UncontrolledCollapse
          toggler="#togglerSupport"
          className="bg-primary-three"
        >
          <DropdownItem
            href={`${COINNIK_MARKET_APP_URL}tickets/list`}
            className="py-2"
          >
            <div className="d-flex align-items-center  ">
              <i className="icon-forum" />
              <span className="px-3 text-white">{t("Send a ticket")}</span>
            </div>
          </DropdownItem>
          <DropdownItem tag={Link} to="/contact-us" className="py-2 ">
            <div className="d-flex align-items-center  ">
              <i className="icon-contact-phone " />
              <span className="px-3 text-white">{t("Contact Us")}</span>
            </div>
          </DropdownItem>
          <DropdownItem tag={Link} to="/faq" className="py-2 ">
            <div className="d-flex align-items-center  ">
              <i className="icon-question" />
              <span className="px-3 text-white">
                {t("Frequently Asked Questions")}
              </span>
            </div>
          </DropdownItem>
          <DropdownItem to="/user-guide" tag={Link}>
            <div className="d-flex align-items-center py-2 ">
              <i className="icon-document " />
              <span className="px-3 text-white">{t("user manual")}</span>
            </div>
          </DropdownItem>
        </UncontrolledCollapse>

        <DropdownItem
          tag={Link}
          to="/commission"
          className="text-white fs-6  mb-4 "
        >
          {t("Fee")}
        </DropdownItem>
        <DropdownItem
          href="https://blog.coinnik.market/"
          className="text-white mb-4"
        >
          {t("Academy")}
        </DropdownItem>
        <div className="pt-4 d-flex  justify-content-around px-5">
          {socialItems.map((item: any) => (
            <SocialNetworks icon={item.icon} link={item.link} />
          ))}
        </div>
      </Container>
    </DropdownMenu>
  );
};
export default MobileMenu;

const SocialNetworks = ({ icon, link }: any) => (
  <a href={link} className="">
    <i className={cn("bg-warning-one border-radius-2 p-2", icon)} />
  </a>
);

const LanguageMenu = ({ t }: any) => {
  const [selectFa, setSelectFa] = useState(true);
  const [selectEn, setSelectEn] = useState(false);

  return (
    <div className="position-static dropdown-menu--dark">
      <Link
        to="#"
        // tag={Link}
        onClick={() => {
          changeLanguagePersian("fa");
          setSelectFa(true);
          setSelectEn(false);
        }}
      >
        <FormGroup className="my-2">
          <Input name="radio" type="radio" checked={selectFa} />
          <Label check className="px-2 ">
            {t("Persian")}
          </Label>
        </FormGroup>
      </Link>
      <Link
        className="my-1"
        // tag={Link}
        to="#"
        onClick={() => {
          changeLanguageEnglish("en");
          setSelectEn(true);
          setSelectFa(false);
        }}
      >
        <FormGroup className="mb-2">
          <Input checked={selectEn} name="radio" type="radio" />
          <Label check className="px-2">
            {t("English")}
          </Label>
        </FormGroup>
      </Link>
    </div>
  );
};

const DigitalCurecnyItems = () => {
  const [search, setSearch] = useState<any>("");
  const [filter, setFilter] = useState<any>([]);
  const { t } = useTranslation();

  let dropdownItemsLocal = dropdownItems();

  const allFilter = filter.length ? filter : dropdownItemsLocal;
  return (
    <>
      <div
        className="position-static
      d-flex flex-column align-items-start text-white bg-primary-three dropdown-menu--dark bg-primary-two height-dropdown-menu  overflowY-auto"
      >
        <Row className="justify-content-center  pt-3">
          <Col xs="10" sm="10">
            <Form className="form-style ">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText className="border-radius-tr-1 border-radius-br-1">
                    <i className="icon-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={search}
                  onChange={(txt: any) => {
                    let filterd = dropdownItemsLocal.filter((item: any) => {
                      return t(item.title).indexOf(txt.target.value) >= 0;
                    });
                    setFilter(filterd);
                    setSearch(txt.target.value);
                  }}
                  type="text"
                  placeholder={t("Search currency name")}
                  className="fs-6 form-control-padding-y text-secondary-nine-light border-radius-tl-1 border-radius-bl-1 "
                />
              </InputGroup>
            </Form>
          </Col>
        </Row>
        {dropdownItemsLocal.length &&
          allFilter.map((item: any) => (
            <a
              className="py-3 pe-3 text-white"
              href={`/coins/${item.title?.toLowerCase()}`}
            >
              <div className="pe-2">
                <img src={item.imgSrc} className="style-dropdown-icon" />
                <span className=""> {t(item.title)}</span>
                <span> {t(item.symbol)}</span>
              </div>
            </a>
          ))}
      </div>
    </>
  );
};

{
  /* <div
              className="d-flex justify-content-between align-items-baseline  d-block d-sm-none"
              id="toggler2"
            >
              <p className="fs-5 text-light">{t("Related Links")} </p>
              <i className="icon-chevron-down" />
            </div>
            <UncontrolledCollapse toggler="#toggler2">
              <ul>
                <li>
                  {" "}
                  <Link to="/security">{t("Security")}</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/commission">{t("Commission")}</Link>
                </li>
                <li>
                  {" "}
                  <a href="https://demoapp.coinnik.market/app/markets/BTC_TMN">
                    {t("Trial version (demo)")}
                  </a>
                </li>
                <li>
                  {" "}
                  <Link to="/user-plan">{t("User levels")}</Link>
                </li>
              </ul>
            </UncontrolledCollapse> */
}
